//
//
//
//
//
//

export default {
	props: ["id", "Data", "name", 'chuangkou', 'manyi', 'hmanyi', 'yiban', 'bu', 'fmanyi'],
	data() {
		return {
			legendName: [],
		};
	},
	mounted() {
		setTimeout(() => {
			this.drawLine();
		}, 1000);
	},
	watch: {
		chuangkou() {
			this.drawLine();
		},
		manyi() {
			this.drawLine();
		},
		hmanyi() {
			this.drawLine();
		},
		yiban() {
			this.drawLine();
		},
		bu() {
			this.drawLine();
		},
		fmanyi() {
			this.drawLine();
		}

	},
	methods: {
		fontSize(res) {
			let docEl = document.documentElement,
				clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			if (!clientWidth) return;
			let fontSize = 100 * (clientWidth / 1920);

			return res * fontSize;
		},
		drawLine() {
			// 基于准备好的dom，初始化echarts实例
			let myChart = this.$echarts.init(document.getElementById('duidie'));
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
					}
				},
				grid: {
					top: '15%',
					left: '5%',
					right: '10%',
					bottom: '0%',
					containLabel: true
				},

				xAxis: {
					type: 'category',
					name: '窗口',
					nameTextStyle: {
						color: "rgba(102,152,255,1)",
						// fontSize:'0.36rem',
						fontSize: this.fontSize(0.1)
					},
					axisLine: {
						lineStyle: {
							color: '#4D30F0'
						}
					},
					data: this.chuangkou.filter(d =>d),
					// data: ['01','02','03','04','05','06','07','08','09','10','11','12','13'],
					splitLine: {
						show: false //网格线不显示
					},
					/////////////不显示刻度
					axisTick: {
						show: false
					},
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							fontWeight: '400',
							color: 'rgba(102,152,255,1)',
							fontSize: this.fontSize(0.1),
							fontFamily: 'Alibaba PuHuiTi'
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '件数',
					nameTextStyle: {
						color: "rgba(102,152,255,1)",
						fontSize: this.fontSize(0.1)
						// fontSize:'0.36rem',
					},
					minInterval: 1,
					splitLine: {
						show: false //网格线不显示
					},
					axisLine: {
						lineStyle: {
							color: '#4D30F0'
						}
					},
					/////////////不显示刻度
					axisTick: {
						show: false
					},
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							fontWeight: '400',
							color: 'rgba(102,152,255,1)',
							fontSize: this.fontSize(0.1),
							fontFamily: 'Alibaba PuHuiTi'
						}
					},

				},
				series: [{
						name: '非常不满意',
						type: 'bar',
						stack: '总量',
						label: {
							normal: {
								show: false,
							}
						},
						barWidth: 13, //柱图宽度
						data: this.bu,
						emphasis: {
							focus: 'series'
						},
						// data: [12, 20, 10, 13,20, 12, 20,2, 10, 14, 13,10, 21],
						color: '#F64D4A'
					},
					{
						name: '不满意',
						type: 'bar',
						stack: '总量',
						label: {
							normal: {
								show: false,
								position: 'insideRight'
							}
						},
						data: this.yiban,
						emphasis: {
							focus: 'series'
						},
						// data: [2, 10, 1, 3,2, 12, 10,2, 4, 4, 13,8, 21],
						color: '#FF8B2E'
					},
					{
						name: '基本满意',
						type: 'bar',
						stack: '总量',
						label: {
							normal: {
								show: false,
								position: 'insideRight'
							}
						},
						color: '#FAC028',
						emphasis: {
							focus: 'series'
						},
						data: this.manyi,
						// data:[12, 20, 15, 13,32, 12, 10,21, 14, 4, 3,8,11]
					},
					{
						name: '满意',
						type: 'bar',
						stack: '总量',
						label: {
							normal: {
								show: false,
								position: 'insideRight'
							}
						},
						color: '#9ecd1f',
						emphasis: {
							focus: 'series'
						},
						data: this.hmanyi,
						// data:[12, 20, 1,23,12, 22, 10,22, 14, 24, 23,18, 11]
					},
					{
						name: '非常满意',
						type: 'bar',
						stack: '总量',
						label: {
							normal: {
								show: false,
								position: 'insideRight'
							}
						},
						color: '#12B376',
						emphasis: {
							focus: 'series'
						},
						data: this.fmanyi,
						// data:[12, 20, 1,23,12, 22, 10,22, 14, 24, 23,18, 11]
					}
				]
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/duidie_zhuxing.vue